import { EligibilityStatus, type EligibilityRequest, type EligibleProduct } from "../types";

export interface EligibilityResultLogFields {
    eligibleCount: number;
    ineligibleCount: number;
    alreadyEnrolledCount: number;
    totalCount: number;
    partner: string;
    isPrecheck: boolean;
    sessionId: string;
    productSkusReturned: string[];
}

export const buildEligibilityResultLog = (
    eligibility: EligibilityRequest,
    productConfigs: EligibleProduct[],
): EligibilityResultLogFields => {
    let eligibleCount = 0;
    let ineligibleCount = 0;
    let alreadyEnrolledCount = 0;
    const productSkusReturned: string[] = [];

    for (const product of productConfigs) {
        productSkusReturned.push(product.productSku);
        if (product.status === EligibilityStatus.Eligible) eligibleCount++;
        else if (product.status === EligibilityStatus.Enrolled) alreadyEnrolledCount++;
        else ineligibleCount++;
    }

    return {
        eligibleCount,
        ineligibleCount,
        alreadyEnrolledCount,
        totalCount: eligibleCount + ineligibleCount + alreadyEnrolledCount,
        partner: eligibility.partner,
        isPrecheck: !!eligibility.eligibilityAttributes?.isPrecheck,
        sessionId: eligibility.sessionId,
        productSkusReturned,
    };
};
